<template>
    <div>
        <title>提交订单</title>
        <section class="serviceBox">
            <main :class="[{'wid80':isFull},{'wid100':!isFull}]">
                <p class="flexBet saleListTit">
                    <em>商品清单</em>
                    <strong class="blueColor" @click="returnPage">返回重新选择</strong>
                </p>
                <!-- S 商品清单 -->
                <GoodsItems eleType="下单" ref="goodsRef" @updateChange="updateChange" @numChange="numChange"></GoodsItems>
                <!-- E 商品清单 -->
                <main class="makeOrder">
                    <div class="flexUpDownCenter">
                      <p class="flexBet makeChose">
                        <span :class="{'on':choseIndex == 0}" @click="getChoseIndex(0)">预下单，后期发货</span>
                        <span :class="{'on':choseIndex == 1,'btnDisabled':allNum>5000}" @click="getChoseIndex(1)">整单，立即发货</span>
                      </p>
                      <em v-show="allNum>5000" class="breathTit iconbulb">单次下单的商品数量超过<b class="redColor">5000</b>，仅支持<i class="blueColor">「预下单，后期发货」</i>；想要<i class="blueColor">「整单，立即发货」</i>下单，请确保下单的商品数量<b class="redColor">低于5000</b>！</em>
                    </div>
                    <!-- S 选择配送方式 -->
                    <DeliveryChose ref="deliveryChose_ref" eleType="下单" :choseIndex="Number(choseIndex)" :preChoseHisAdd="preChoseHisAdd" :userInfo="userInfo" :goodsType="saleType"></DeliveryChose>
                    <!-- E 选择配送方式 -->
                </main>
                <div class="bottomBtn">
                    <el-button type="primary" @click="getSubmit">提交</el-button>
                    <el-button @click="$router.back(-1)">取消</el-button>
                </div>
            </main>
        </section>
        
        <!-- S 预下单的系统提示 -->
        <el-dialog class="comDlog codeDlog" title="提示" :visible.sync="preorderDlog" :before-close="getClose" :modal-append-to-body="false" append-to-body :close-on-click-modal="false">
            <section class="flexUI">
                <i class="el-message__icon el-icon-success greenColor"></i>
                <div v-if="submitInfo">
                    <p>预下单提交成功！</p>
                    <p>销售单号：<b id="bar">{{submitInfo.saleorderno}}</b>
                        <em class="blueColor copyEm autoCopy" data-clipboard-action="copy" data-clipboard-target="#bar" @click="handleCopy">复制</em>
                    </p>
                    <small class="greyColor"><strong class="redColor">{{second}}s</strong>&nbsp;后自动进入列表页可继续下单</small>
                </div>
            </section>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="getClose">关闭</el-button>
            </span>
        </el-dialog>
        <!-- E 预下单的系统提示 -->
        <!-- S 整单的系统提示 -->
        <WholeSubmitSuccess :wholeOrderDlog="wholeOrderDlog" :submitInfo="submitInfo?submitInfo:''" :successData="successData" :saleType="saleType" @closeCld="getCloseWholeDlog"></WholeSubmitSuccess>
        <!-- E 整单的系统提示 -->
        <!-- S 绑定会员弹窗 -->
        <!-- <MemberChose :memberChoseDialogVisible="memberChoseDialogVisible" :memberLists="memberInfo" @selected="members" @closeChild="getCloseMemberCld"></MemberChose> -->
        <!-- <BindMember :bindMemberDlog="bindMemberDlog" @closeChild="getCloseBindMem"></BindMember> -->
        <!-- E 绑定会员弹出 -->
        <!-- S 历史地址信息弹窗 -->
        <!-- <HistoryAddMsg :historyAddDlog="historyAddDlog" @closeChild="getCloseHisAdd"></HistoryAddMsg> -->
        <!-- E 历史地址信息弹窗 -->
    </div>
</template>
<script>
import { MessageBox } from "element-ui";
import Clipboard from "clipboard";
import { mapState, mapActions } from "vuex";
import api from '@/apis/api.js';
export default {
    name:'GoodsSaleSubmit',
    data(){
        return{
            payStatu:true,//消费者付款状态
            
            choseIndex:0,//下单方式，默认0：预下单
            
            isClerk:false,//是否选中店员
            preorderDlog:false,//预下单的弹出框
            second:3,//关闭提示弹窗倒计时
            wholeOrderDlog:false,//整单的弹出框
            saleType:0,//商品类型0：实物 1：券卡
            screenWidth: document.documentElement.clientWidth,//屏幕宽度
            isFull:false,//是否100%宽度展示
            memberChoseDialogVisible:false,//绑定会员弹窗显隐
            isBindMem:false,//是否有绑定会员
            historyAddDlog:false,//查看历史记录弹窗显隐
            preChoseHisAdd:'',//选中的历史地址信息
            userInfo: '', // 登录信息
            firstTrue: true, // 防止多次点击
            submitInfo: '', // 下单成功返回的信息
            secondSet: null, // 接收定时器
            successData: null, // 传递订单信息
            totalDiscountPrice: 0, // 订单的总金额
            allNum: 0, // 总的商品数量
        }
    },
    watch:{
        isHelp(val){ //监听屏幕宽度变化
            this.isFull = val
        }
    },
    // ==================================== 计算属性 ====================================
    computed: {
        ...mapState({
            isHelp: ({ common }) => common.isHelp,
        })
    },
    components:{
        GoodsItems: resolve => require(["@/components/OrderFolder/StoreSale/GoodsItems.vue"], resolve),//商品清单
        DeliveryChose: resolve => require(["@/components/OrderFolder/StoreSale/DeliveryChose.vue"], resolve),//选择配送方式
        WholeSubmitSuccess: resolve => require(["@/components/OrderFolder/StoreSale/WholeSubmitSuccess.vue"], resolve),//整单提交成功
        
        MemberChose: resolve =>require(["@/components/common/MemberChose.vue"], resolve), //选择会员
    },
    methods:{
        // 接收传递过来的中商品数量
        numChange(num) {
            this.allNum = num;
            if(this.choseIndex == 1&&this.allNum>5000) {
                this.choseIndex = 0;
            }
        },
        // 接收商品的总金额
        updateChange(val) {
            this.totalDiscountPrice = val;
        },
        // 返回上一级
        returnPage() {
            this.$router.push({
                name: this.saleType==0?'实物商品销售':'券卡商品销售',
                query: {
                    getOldGoods: 1
                }
            })
        },
        // 切换下单方式
        getChoseIndex(index){
            if(index == 1&&this.allNum>5000) {
                return false;
            }
            this.choseIndex = index;
        },
        
        // 提交
        getSubmit(){
            this.$refs.deliveryChose_ref.getValidatePromise().then(res => {
                console.log(res.data,'res.data')
                if(res.valid) {
                    if(!res.data.channelcode) {
                        this.$message({
                            type: 'error',
                            message: '请选择销售渠道！'
                        })
                        return false;
                    }
                    if(this.saleType!=1&&this.choseIndex == 1) {
                        // 判断实物下单是否触发控价
                        this.isNeedContrPrice(res);
                    } else {
                        this.orderSubmit(res);
                    }
                }
            })
        },
        // 判断实物下单是否触发控价
        isNeedContrPrice(info) {
            api.ISNEEDCONTRPRICE({membercode:info.data.membercode}).then(res => {
                if(res.data.status == "200") {
                    if(res.data.data&&res.data.data.active) {
                        this.$alert(`亲，此订单${res.data.data.active==1?'触发控价':(res.data.data.active==2?'触发风控':'为零金额订单')}，只能选择预下单哦！`, '系统提示', {
                            confirmButtonText: '确定',
                            type: 'warning',
                            callback: action => {
                            }
                        });
                        // this.$message({
                        //     type:'info',
                        //     message: `亲，此订单${res.data.data.active==1?'触发控价':'触发风控'}，只能选择预下单哦！`
                        // })
                        this.choseIndex = 0;
                    } else {
                        this.orderSubmit(info);
                    }
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.message
                    })
                }
            })
        },
        // 订单提交接口
        orderSubmit(res) {
            let subParams = {
                subtype: this.choseIndex,
                goodstype: this.saleType,
                consumerpaystatus: res.data.consumerpaystatus,
                corderuname: this.userInfo.objtype==0?res.data.corderuname:this.userInfo.linkman,
                corderucode: this.userInfo.objtype==0?res.data.corderucode:this.userInfo.flowcode,
                membercode: res.data.membercode,
                nickname: res.data.nickname,
                terminaltype: 0,
                subordmemo: res.data.sendmemo,
                bdistribution: res.data.bdistribution,
                channelcode: res.data.channelcode, // 渠道编号
                channelname: res.data.channelname, // 渠道名称
                allamount: this.totalDiscountPrice, // 订单总金额
            }
            let goodsItemArr = this.$refs.goodsRef.goodsItemArr;
            let realPriceList = this.$refs.goodsRef.realPriceList;
            let kindcodeArr = this.$refs.goodsRef.kindcodeArr;
            let goodsinfo = [];
            if(goodsItemArr&&goodsItemArr.length>0) {
                goodsItemArr.forEach(item => {
                    let index = kindcodeArr.indexOf(item.kindcode);
                    let info = {
                        goodscode: item.goodscode,
                        kindcode: item.kindcode,
                        price: realPriceList[index],
                        num: item.goodsNum
                    }
                    goodsinfo.push(info);
                })
            }
            subParams.goodsinfo = goodsinfo;
            if(this.saleType !=1) {
                subParams.printmemo = res.data.printmemo;
                console.log(subParams.printmemo,'subParams.printmemo,subParams.printmemo')
            }
            if(this.choseIndex == 1) {
                subParams.delimode = res.data.delimode;
                if(!res.data.delimode) {
                    subParams.receiverinfo = {
                        receivername: res.data.receivername,
                        receivertel: res.data.receivertel,
                        subordmemo: res.data.sendmemo
                    }
                } else {
                    subParams.buyermemo = res.data.buyermemo;
                    subParams.recvdate = res.data.recvdate;
                    subParams.receiverinfo = {
                        receivername: res.data.receivername,
                        receivertel: res.data.receivertel,
                        provincecode: res.data.provincecode,
                        province: res.data.province,
                        citycode: res.data.citycode,
                        city: res.data.city,
                        districtcode: res.data.districtcode,
                        district: res.data.district,
                        addrdet: res.data.addrdet,
                    }
                }
            } else {
                subParams.baddress = res.data.baddress;
                // subParams.bdistribution = res.data.bdistribution;
                if(res.data.baddress) {
                    subParams.receiverinfo = {
                        receivername: res.data.receivername,
                        receivertel: res.data.receivertel,
                        provincecode: res.data.provincecode,
                        province: res.data.province,
                        citycode: res.data.citycode,
                        city: res.data.city,
                        districtcode: res.data.districtcode,
                        district: res.data.district,
                        addrdet: res.data.addrdet,
                    }
                }
            }
            if(this.firstTrue) {
                this.firstTrue = false;
                api.SAVESALEORDER(subParams).then(res => {
                    if(res.data.status == "200") {
                        this.submitInfo = res.data.data;
                        // 预下单
                        if(this.choseIndex == 0){
                            this.preorderDlog = true;
                            this.second = 3;
                            this.secondSet = setInterval(()=>{
                                if(this.second > 1){
                                    this.second --;
                                }else{
                                    clearInterval(this.secondSet);
                                    this.secondSet = null;
                                    this.preorderDlog = false;
                                    let pathName = '/GoodsSale';
                                    if(this.saleType) {
                                        pathName = '/CardSale'
                                    }
                                    this.$router.push({
                                        path:pathName
                                    })
                                }
                            },1000)
                        }else if(this.choseIndex == 1){
                            this.successData = {
                                delimode: subParams.delimode,
                                receivertel: subParams.receiverinfo.receivertel,
                                receivername: subParams.receiverinfo.receivername,
                                sendmemo: subParams.subordmemo,
                                buyermemo: subParams.buyermemo,
                                addrdet: subParams.receiverinfo.addrdet,
                                province: subParams.receiverinfo.province,
                                city: subParams.receiverinfo.city,
                                district: subParams.receiverinfo.district,
                                printmemo: subParams.printmemo,
                            }
                            // 整单
                            this.wholeOrderDlog = true;
                        }
                    } else if(res.data.status == "500") {
                        this.$message({
                            type: 'error',
                            message: res.data.message,
                            offset: 200
                        });
                        this.firstTrue = true;
                    } else {
                        MessageBox.alert(`${res.data.message}`, '系统提示', {
                            confirmButtonText: '确定',
                            type:'warning',
                            dangerouslyUseHTMLString:true,
                            customClass:'subMsg'
                        });
                        this.firstTrue = true;
                    }
                }).catch(res => {
                    this.firstTrue = true;
                })
            }
        },
        // 关闭预下单提示弹窗
        getClose(){
            clearInterval(this.secondSet);
            this.secondSet = null;
            this.preorderDlog = false;
            let pathName = '/GoodsSale';
            if(this.saleType) {
                pathName = '/CardSale'
            }
            this.$router.push({
                path:pathName
            })
        },
        // 关闭整单提示弹窗
        getCloseWholeDlog(type){
            this.wholeOrderDlog = false;
            let path = ''
            if(type==1){
             path = '/CardSale'
            }else{
              path = '/GoodsSale'
            }
            this.$router.push({
                path:path
            })
        },
        // 复制链接
        handleCopy() {
            var clipboard = new Clipboard(".autoCopy");
            clipboard.on("success", e => {
                this.$message({
                    type: 'success',
                    message: '已成功复制到剪贴板!',
                    offset: 200
                });
                // 释放内存
                clipboard.destroy();
            });
            clipboard.on("error", e => {
                // 不支持复制
                this.$message({
                    type: 'warning',
                    message: '该浏览器不支持一键复制!',
                    offset: 200
                });
                // 释放内存
                clipboard.destroy();
            });
        },
        // 获取宽度
        getWidth(){
            this.screenWidth = document.documentElement.clientWidth; //窗口宽度
            if(this.screenWidth<=1500){
                this.isFull = false
            }else{
                this.isFull = true;
            }
        },
        
        
        // 会员信息
        // members(val){
        //     this.memberInfo =val;
        //     // if(val.nickname&&val.mphone){
        //     //     this.basicForm.flowname = val.mphone+'-'+val.nickname;
        //     // }else if(val.nickname){
        //     //     this.basicForm.flowname = val.nickname;
        //     // }else{
        //     //     this.basicForm.flowname = val.mphone;
        //     // }
        // },
        
    },
    created() {
        //页面浏览器视窗变化绑定resize事件
        window.addEventListener("resize", this.getWidth);
    },
    mounted(){
        this.choseIndex = this.$route.query.choseIndex;//父页面传来的下单方式
        this.saleType = Number(this.$route.query.saleType);//父页面传来的商品类型0：实物 1：券卡
        this.getWidth();//获取浏览器宽度
        if(localStorage.getItem('userInfoMd')&&localStorage.getItem('userInfoMd')!=undefined) {
            this.userInfo = JSON.parse(localStorage.getItem('userInfoMd'));
        }
    },
    destroyed(){ 
        // window.removeEventListener('resize', this.getWdith); //销毁监听浏览器视窗变化
    }
}
</script>
<style scoped>
.mainPart {
    padding: 20px;
    height: calc(100% - 50px);
}
.saleListTit{margin: 0 0 20px 0;}
.saleListTit em{
    font-size: 22px;
}
.saleListTit strong{cursor: pointer;}
.makeOrder{
    margin-top: 20px;
}
.makeOrder .makeChose{
    border: 1px solid #DCDFE6;
    width: 320px;
    box-sizing: border-box;
    height: 45px;
    line-height: 45px;
}
.makeOrder .makeChose span{
    /* width: 49%; */
    flex:1;
    text-align: center;
    position: relative;
    cursor: pointer;
    overflow: hidden;
}
.makeOrder .makeChose span:first-child{
    border-right: 1px solid #DCDFE6;
}
.makeOrder .makeChose span.on::after{
    position: absolute;
    right: -2px;
    bottom: -10px;
    font-size: 30px;
    content: "\e637";
    color: var(--main-color);
    font-family: "iconfont" !important;
}
.makeOrder .makeChose .btnDisabled {background:#f5f5f5; cursor: not-allowed;color:#999;}
.serviceBox{
    padding: 20px 20px 85px;
    height: calc(100% - 105px);
    overflow-y: auto;
}
.codeDlog >>> .el-dialog {
  width: 420px;
}
.codeDlog >>> .el-button {
  padding: 8px 15px;
}
.codeDlog >>> .el-dialog__body {
  padding: 13px 20px 20px 20px;
}
.codeDlog >>> .el-dialog__footer {
  box-shadow: none;
  margin-bottom: 5px;
}
.codeDlog>>>.el-icon-success{font-size: 24px;line-height: 24px;}
.copyEm{cursor: pointer;margin-left: 10px;}
.codeDlog p{
  color: #666;
  line-height: 24px;
}
.codeDlog p:first-child{color: #333;font-size: 18px;}
.wid80{width: 80%;}
.wid100{width: 100%;}
.bindMem{
    padding: 6px 12px;
    text-align: center;
    border-radius: 20px;
    display: inline-block;
    cursor: pointer;
}
.bindMem{
    background: var(--main-color) !important;
    border-color: var(--main-color) !important;
    color: #fff;
    margin-left: 15px;
}
.bindMem:hover{
    background: var(--main-color) !important;
    border-color: var(--main-color) !important;
}
.inlineMember{margin-left: 10px;border: none;}
.inlineMember a:first-child{
    position: relative;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    overflow: hidden;
    border: solid 1px #ebeef5;
    margin: 0 5px 0 10px;
}
.inlineMember span {
    margin-right: 10px;
}
.inlineMember i{
    color: #999;
}
.inlineMember em {
    max-width: 180px;
}
.inlineMember *{
    display: inline-block;
    vertical-align: top;
    font-size: 14px;
}
.inlineMember .el-link{
    margin: 0 5px;
}
.inlineMember .el-link span{margin-right: 0;}
.breathTit{margin-left: 10px;}

</style>


// WEBPACK FOOTER //
// src/views/OrderFolder/StoreSale/GoodsSaleSubmit.vue